import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function LocationIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_228_5955)">
          <path
            d="M10 10.6154C11.3634 10.6154 12.4687 9.51332 12.4687 8.15385C12.4687 6.79438 11.3634 5.69231 10 5.69231C8.6366 5.69231 7.53135 6.79438 7.53135 8.15385C7.53135 9.51332 8.6366 10.6154 10 10.6154Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.1716 8.15385C16.1716 13.6923 10 18 10 18C10 18 3.82837 13.6923 3.82837 8.15385C3.82837 6.52174 4.47859 4.95649 5.636 3.80242C6.7934 2.64835 8.36318 2 10 2C11.6368 2 13.2066 2.64835 14.364 3.80242C15.5214 4.95649 16.1716 6.52174 16.1716 8.15385Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_228_5955">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  )
}
